import React from 'react';
import { FaDotCircle } from 'react-icons/fa';
const DoctorsDetails = () => {
  return (
    <div className="py-4 px-[8%]">
      <div className="w-full relative h-24 py-5 bg-slate-900 text-white text-center">
        <h1 className="text-4xl font-bold">Doctors Portal</h1>
      </div>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 gap-5"
        data-aos="fade-down"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center w-full BoxTwo h-72 ">
          <div className="divTwo div2"></div>

          <h1 className="text-3xl font-bold text-slate-900">Home Page</h1>
        </div>
        <div className="text-center dashboard2">
          <div className="dashTwo dash2"></div>

          <h1 className="text-3xl font-bold text-slate-900">Dashboard</h1>
        </div>
      </div>

      <div className=" text-center mt-32 mx-auto">
        <h1 className="text-3xl font-bold mb-7 ">
          Used Languages and Technologies
        </h1>
        <div className="usedTechnologies grid grid-cols-6 my-6 mx-auto w-[90%] text-center justify-center">
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://iconape.com/wp-content/png_logo_vector/tailwind-css-logo.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcEPtZG69vhynupLCfGDE1KhYCaLQkoiPXFTEFK00Wv1OLQROIt61A7gAXzo93N66rrIw&usqp=CAU"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://www.pngitem.com/pimgs/m/385-3850320_png-transparent-mongodb-icon-mongodb-logo-png-download.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full text-center justify-center">
            <img
              src="https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
        </div>
      </div>
      <div
        className="details"
        data-aos="fade-down"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center">
          <h1 className="text-2xl text-slate-900 font-bold">
            Doctors Portal (
            <a className="text-blue-600" href="https://drbelalvai.web.app/home">
              Live Site
            </a>
            :{' '}
            <a
              className="text-blue-600"
              href="https://github.com/kutub98/doctorsPortal"
            >
              Client Code
            </a>{' '}
            :{' '}
            <a
              className="text-blue-600"
              href="https://github.com/kutub98/doctors-portal-server"
            >
              Server Code
            </a>
            )
          </h1>
        </div>
        <div className="">
          <h1>
            It's based on Selling and buying used product. Here sellers can sell
            bikes and buyers can buy books, and the admin will be able to
            observe all the bikes.
          </h1>
          <ul>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Login system with firebase, private routes and dashboard for
              admins and users.
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Users can take appointment in one time in day from one treatment
              option.
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Admin /Doctor can add Doctor or service,
            </li>
            <li className="flex items-center">
              {' '}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Database Integration, Implementing Authentication & Authorization,
              Secure Token using JWT
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DoctorsDetails;
